<template>
  <v-container fluid>
    <svg class="clientsvg" width="100%" height="600" font-size="10" text-anchor="middle"/>
    <v-dialog
      max-width='320'
      content-class='client-dialog'
      v-model='dialog'
    >
        <v-card flat>
          <v-card-title class="align-end">{{client}}</v-card-title>
          <light-timeline v-if="timeline.length>0" :items='timeline'></light-timeline>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as d3 from 'd3/dist/d3'
import PublicLandingApi from '@/services/PublicLandingApi';
import parseFns  from 'date-fns/parse';
import formatFns from 'date-fns/format';
export default {
  data() {
    return {
      dialog: false,
      clients: null,
      client: null,
      clientLogo:null,
      timeline: [],
      tsclients: []
    }
  },  
  mounted() {
    this.getClients().then((clients)=>{
      this.clients = clients;
      this.init(clients);
      window.addEventListener('resize',this.redraw);
    });
  },
  methods: {
    redraw(){
      if(this.clients){
        this.init(this.clients)
      }
    },
    init(clients){
      function ticked() {
        // eslint-disable-next-line
        node
          .attr('transform', d => `translate(${d.x},${d.y})`)
          .select('circle')
            .attr('r', d => d.r);
      }
      d3.select(".clientsvg").selectAll("*").remove();
      let svg = d3.select('.clientsvg');
      
      let width = document.body.clientWidth; // get width in pixels
      let height = 600;
      let centerX = width * 0.5;
      let centerY = height * 0.5;
      let strength = 0.05;
      // eslint-disable-next-line
      let focusedNode;

      let pack = d3.pack()
        .size([width , height ])
        .padding(1.5);

      let forceCollide = d3.forceCollide(d => d.r + 1);

      // use the force
      let simulation = d3.forceSimulation()
        .force('charge', d3.forceManyBody())
        .force('collide', forceCollide)
        .force('x', d3.forceX(centerX).strength(strength))
        .force('y', d3.forceY(centerY).strength(strength));

      let root = d3.hierarchy({ children: clients })
        .sum(d => d.value);

      let nodes = pack(root).leaves().map(node => {
        const data = node.data;
        return {
          x: centerX + (node.x - centerX) * 3, // magnify start position to have transition to center movement
          y: centerY + (node.y - centerY) * 3,
          r: 0, // for tweening
          radius: data.name === 'Gatso' ? node.r / 2 : node.r * 2, 
          id: data.id,
          name: data.name,
          value: data.value,
          icon: data.icon,
          colour: data.colour,
        }
      });
      simulation.nodes(nodes).on('tick', ticked)

      svg.style('background-color', '#FAFAFA');
      let node = svg.selectAll('.node')
        .data(nodes)
        .enter().append('g')
        .attr('class', 'node')
        .call(d3.drag()
          .on('start', (d) => {
            if (!d3.event.active) simulation.alphaTarget(0.2).restart();
            d.fx = d.x;
            d.fy = d.y;
          })
          .on('drag', (d) => {
            d.fx = d3.event.x;
            d.fy = d3.event.y;
          })
          .on('end', (d) => {
            if (!d3.event.active) simulation.alphaTarget(0);
            d.fx = null;
            d.fy = null;
          }));

      node.append('circle')
        .attr('id', d => d.id)
        .attr('r', 0)
        .style('fill', d => d.colour)
        .transition().duration(2000).ease(d3.easeElasticOut)
          .tween('circleIn', (d) => {
            let i = d3.interpolateNumber(0, d.radius);
            return (t) => {
              d.r = i(t);
              simulation.force('collide', forceCollide);
            }
          })

      node.append('clipPath')
        .attr('id', d => `clip-${d.id}`)
        .append('use')
        .attr('xlink:href', d => `#${d.id}`);

      // display image as circle icon
      node.filter(d => String(d.icon).includes('data:'))
        .append('image')
        .classed('node-icon', true)
        .attr('clip-path', d => `url(#clip-${d.id})`)
        .attr('xlink:href', d => d.icon)
        .attr('x', d => - d.radius * 0.7)
        .attr('y', d => - d.radius * 0.7)
        .attr('height', d => d.radius * 2 * 0.7)
        .attr('width', d => d.radius * 2 * 0.7)
      node.append('title')
        .text(d => (d.name));     

      let infoBox = node.append('foreignObject')
        .classed('circle-overlay hidden', true)
        .attr('x', -350 * 0.5 * 0.7)
        .attr('y', -350 * 0.5 * 0.7)
        .attr('height', 350 * 0.7)
        .attr('width', 350 * 0.7)
          .append('xhtml:div')
          .classed('circle-overlay__inner', true);
      infoBox.append('h3')
        .classed('circle-overlay__title', true)
        .text(d => d.name);
      infoBox.append('p')
        .classed('circle-overlay__body', true)
        .html(d => d.name);
      node.on('click', (currentNode) => {
        d3.event.stopPropagation();
        // console.log('currentNode', currentNode);
        this.client = currentNode.name;
        this.clientLogo = currentNode.icon;
        this.getProjects(currentNode.id).then((projects)=>{
          let timelineItems=[];
          for(let project of projects) {
            let tag = formatFns(
                parseFns('20'+project.job_id.substring(0, 2)+'-'+project.job_id.substring(2, 4),'yyyy-MM', new Date())
              ,'MMM yyyy');
            timelineItems.push({
              tag: tag,
              content: project.title,
              class: project.ProjectType.type.toLowerCase().replace(/ /g,''),
              type: 'circle',
              color: 'orange'
            });
          }
          this.timeline = timelineItems;
          this.dialog = true;
        });        
        let currentTarget = d3.event.currentTarget; // the <g> el
        if (currentNode === focusedNode) {
          // no focusedNode or same focused node is clicked
          return;
        }
        let lastNode = focusedNode;
        focusedNode = currentNode;
        simulation.alphaTarget(0.2).restart();
        // hide all circle-overlay
        d3.selectAll('.circle-overlay').classed('hidden', true);
        d3.selectAll('.node-icon').classed('node-icon--faded', false);
        // don't fix last node to center anymore
        if (lastNode) {
          lastNode.fx = null;
          lastNode.fy = null;
          node.filter((d, i) => i === lastNode.index)
            .transition().duration(2000).ease(d3.easePolyOut)
            .tween('circleOut', () => {
              let irl = d3.interpolateNumber(lastNode.r, lastNode.radius);
              return (t) => {
                lastNode.r = irl(t);
              }
            })
            .on('interrupt', () => {
              lastNode.r = lastNode.radius;
            });
        }

        d3.transition().duration(2000).ease(d3.easePolyOut)
          .tween('moveIn', () => {
            let ix = d3.interpolateNumber(currentNode.x, centerX);
            let iy = d3.interpolateNumber(currentNode.y, centerY);
            let ir = d3.interpolateNumber(currentNode.r, centerY * 0.4);
            return function (t) {
              currentNode.fx = ix(t);
              currentNode.fy = iy(t);
              currentNode.r = ir(t);
              simulation.force('collide', forceCollide);
            };
          })
          .on('end', () => {
            simulation.alphaTarget(0);
            let $currentGroup = d3.select(currentTarget);
            $currentGroup.select('.circle-overlay')
              .classed('hidden', false);
            $currentGroup.select('.node-icon')
              .classed('node-icon--faded', true);
          })
          .on('interrupt', () => {
            currentNode.fx = null;
            currentNode.fy = null;
            simulation.alphaTarget(0);
          });
      });
      // blur
      d3.select(document).on('click', () => {
        let target = d3.event.target;
        // check if click on document but not on the circle overlay
        if (!target.closest('#circle-overlay') && focusedNode) {
          focusedNode.fx = null;
          focusedNode.fy = null;
          simulation.alphaTarget(0.2).restart();
          d3.transition().duration(2000).ease(d3.easePolyOut)
            .tween('moveOut', function () {
              let ir = d3.interpolateNumber(focusedNode.r, focusedNode.radius);
              return function (t) {
                focusedNode.r = ir(t);
                simulation.force('collide', forceCollide);
              };
            })
            .on('end', () => {
              focusedNode = null;
              simulation.alphaTarget(0);
            })
            .on('interrupt', () => {
              simulation.alphaTarget(0);
            });
          // hide all circle-overlay
          d3.selectAll('.circle-overlay').classed('hidden', true);
          d3.selectAll('.node-icon').classed('node-icon--faded', false);
        }
      });

    },
    async getClients() {
      try {
        const response = await PublicLandingApi.clients()
        return response.data.clients;
      } catch(err) {
        console.log(err)
      }
    },
    async getProjects(id) {
      try {
        const response = await PublicLandingApi.projects(id)
        return response.data.projects;
      } catch(err) {
        console.log(err)
      }
    }    
  }
}
</script>

<style>
  .clientsvg {
    display:block;
  }
  .circle-overlay {
    font-size: 16px;
    border-radius: 50%;
    position: absolute;
    overflow: hidden;
    /*it's buggy with the foreignObject background right now*/
    /* background-color: rgba(255,255,255,0.5); */
  }
  .circle-overlay__inner {
    text-align: center;
    width: 100%;
    height: 100%;
  }

  .circle-overlay__title{
    margin-top: 60px;
  }
  .hidden {
    display: none;
  }

  .node-icon--faded {
    opacity: 0.1;
  }

  .legend-size circle {
    fill: rgb(31, 119, 180);
  }

  .client-dialog {
    margin-top: 100px !important;
    background-color: #ffffff;
  }
</style>